import { useContext } from 'react';
import { UserDataContext } from 'lane-shared/contexts';
import { PERMISSION_KEYS } from 'constants-permissions';
import hasPermission from 'lane-shared/helpers/hasPermission';
import { ExternalReference } from 'graphql-query-contracts';

type Unit = {
  id: string;
  name: string;
  description?: string | null;
  floors?:
    | ({
        id: string;
        name?: string;
        index?: number;
      } | null)[]
    | null;
  externalReferences?: ExternalReference[];
};

export const useExternalReference = (unit: Unit, channelId: string) => {
  const { user } = useContext(UserDataContext);

  const enableExternalReference =
    user?.isSuperUser ||
    hasPermission(user?.roles, [PERMISSION_KEYS.PERMISSION_ADMIN], channelId);

  const externalReference = enableExternalReference
    ? (unit.externalReferences?.[0] ?? null)
    : null;

  return {
    enableExternalReference,
    externalReference,
  };
};
